import { useSearchParams } from 'react-router-dom';
import {
  isNullOrWhitespace,
  stringToBool,
  stringToDate,
  stringToNumberDefault1
} from '../helpers/string-helper';
import { useState } from 'react';

const useUrlParams = () => {
  const [searchParams] = useSearchParams();

  const urlQuery = {
    urlBatchID: searchParams.get('batchID'),

    urlShipmentID: searchParams.get('shipmentID'),
    urlShipmentName: searchParams.get('shipmentName'),
    urlPackingListNumber: searchParams.get('packingListNumber'),
    urlDestinationFC: searchParams.get('destinationFC'),
    urlDestinationAddress: searchParams.get('destinationAddress'),
    urlDestinationAddressBasic: searchParams.get('destinationAddressBasic'),
    urlAmazonReferenceID: searchParams.get('amazonReferenceID'),
    urlShipmentProNumber: searchParams.get('shipmentProNumber'),
    urlShipmentPalletNumber: searchParams.get('shipmentPalletNumber'),

    urlProductSku: searchParams.get('sku'),
    urlProductFnSku: searchParams.get('fnsku'),
    urlProductName: searchParams.get('name'),
    urlProductAsin: searchParams.get('asin'),
    urlProductID: searchParams.get('itemID'),
    urlProductQty: stringToNumberDefault1(searchParams.get('ItemQty')),
    urlProductImage: searchParams.get('image') ?? './images/placeholder.png',
    urlProductExpirationDate: stringToDate(searchParams.get('expiration')),
    urlPrintFnSkuOnLabel: stringToBool(searchParams.get('printFnSkuOnLabel')),

    urlLiquidationLotCode: searchParams.get('lotCode'),
    urlLiquidationSequence: stringToNumberDefault1(searchParams.get('sequence')),
    urlLiquidationLpn: searchParams.get('lpn'),

    urlPrintQty: stringToNumberDefault1(searchParams.get('printQty')),
    urlBoxStartCount: stringToNumberDefault1(searchParams.get('boxStart'))
  };
  const [batchID, setBatchID] = useState<string>(urlQuery.urlBatchID ?? '');

  const [shipmentID, setShipmentID] = useState<string>(urlQuery.urlShipmentID ?? '');
  const [shipmentName, setShipmentName] = useState<string>(urlQuery.urlShipmentName ?? '');
  const [packingListNumber, setPackingListNumber] = useState<string>(
    urlQuery.urlPackingListNumber ?? ''
  );
  const [destinationFC, setDestinationFC] = useState<string>(urlQuery.urlDestinationFC ?? '');
  const [destinationAddress, setDestinationAddress] = useState<string>(
    urlQuery.urlDestinationAddress ?? ''
  );
  const [destinationAddressBasic, setDestinationAddressBasic] = useState<string>(
    urlQuery.urlDestinationAddressBasic ?? ''
  );
  const [amazonReferenceID, setAmazonReferenceID] = useState<string>(
    urlQuery.urlAmazonReferenceID ?? ''
  );
  const [shipmentProNumber, setShipmentProNumber] = useState<string>(
    urlQuery.urlShipmentProNumber ?? ''
  );
  const [shipmentPalletNumber, setShipmentPalletNumber] = useState<string>(
    urlQuery.urlShipmentPalletNumber ?? ''
  );
  const isShipmentOnHold = !isNullOrWhitespace(shipmentID)
    ? shipmentID.trim().toLowerCase() === 'hold'
    : false;

  const [productSku, setProductSku] = useState<string>(urlQuery.urlProductSku ?? '');
  const [productFNSku, setProductFNSku] = useState<string>(urlQuery.urlProductFnSku ?? '');
  const [productName, setProductFName] = useState<string>(urlQuery.urlProductName ?? '');
  const [productASIN, setProductASIN] = useState<string>(urlQuery.urlProductAsin ?? '');
  const [productID, setProductID] = useState<string>(urlQuery.urlProductID ?? '');
  const [productQty, setProductQty] = useState<number>(urlQuery.urlProductQty);
  const [productImage, setProductImage] = useState<string>(urlQuery.urlProductImage);
  const [productExpiration, setProductExpiration] = useState<Date | null>(
    urlQuery.urlProductExpirationDate
  );

  const [liquidationLotCode, setLiquidationLotCode] = useState<string>(urlQuery.urlLiquidationLotCode ?? '');
  const [liquidationSequence, setLiquidationSequence] = useState<number>(
    urlQuery.urlLiquidationSequence ?? ''
  );
  const [liquidationLpn] = useState<string>(urlQuery.urlLiquidationLpn ?? '');

  const [printQty, setPrintQty] = useState<number>(urlQuery.urlPrintQty);
  const [printFnSkuOnLabel, setPrintFnSkuOnLabel] = useState<boolean>(
    urlQuery.urlPrintFnSkuOnLabel
  );
  const [boxStartCount] = useState<number>(urlQuery.urlBoxStartCount ?? 1);

  const productCondition = 'NEW ITEM';

  const resetAll = () => {
    setBatchID('');
    setShipmentID('');
    setShipmentName('');
    setPackingListNumber('');
    setDestinationFC('');
    setDestinationAddress('');
    setDestinationAddressBasic('');
    setAmazonReferenceID('');
    setShipmentProNumber('');
    setShipmentPalletNumber('');

    setProductSku('');
    setProductFNSku('');
    setProductFName('');
    setProductASIN('');
    setProductID('');
    setProductQty(1);
    setProductImage('');
    setProductExpiration(null);
    setPrintFnSkuOnLabel(false);

    setLiquidationLotCode('');
    setLiquidationSequence(1);

    setPrintQty(1);
  };

  return {
    resetAll,

    batchID,
    setBatchID,

    shipmentID,
    setShipmentID,
    shipmentName,
    setShipmentName,
    packingListNumber,
    setPackingListNumber,
    destinationFC,
    setDestinationFC,
    destinationAddress,
    setDestinationAddress,
    destinationAddressBasic,
    setDestinationAddressBasic,
    amazonReferenceID,
    setAmazonReferenceID,
    shipmentProNumber,
    setShipmentProNumber,
    shipmentPalletNumber,
    setShipmentPalletNumber,
    isShipmentOnHold,

    productSku,
    setProductSku,
    productFNSku,
    setProductFNSku,
    productName,
    setProductFName,
    productASIN,
    setProductASIN,
    productID,
    setProductID,
    productQty,
    setProductQty,
    productImage,
    setProductImage,
    productExpiration,
    setProductExpiration,
    printFnSkuOnLabel,
    setPrintFnSkuOnLabel,
    productCondition,

    liquidationLotCode,
    setLiquidationLotCode,
    liquidationSequence,
    setLiquidationSequence,
    liquidationLpn,


    printQty,
    setPrintQty,
    boxStartCount
  };
};

export default useUrlParams;
